export default {"src":"/_next/static/media/select-up.11136024.svg","height":16,"width":16};